import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {takeUntil} from "rxjs/operators";
import {InternalTradeOrderViewService} from '../../../services/internal/internal-trade-order-view.service';
import {FieldRequest} from '../../../model/api/field-request';
import {CcBaseComponent} from '../../../crystal-elements/cc-base.component';
import {CommonFieldService} from '../../../services/common/common-field.service';
import {FieldRecord} from '../../../model/api/field-record';
import {ExchangeDetail} from '../../../model/exchange/exchange-detail';
import {CookieNames} from '../../../shared/cookie/cookie-names';
import {UserInfoStorageService} from '../../../services/auth/user-info-storage.service';
import {OrdersTradesFilter} from '../../../model/clearing/orders-trades-filter';
import {WebTradeOrderView} from "../../../model/internal/web-trade-order-view";
import {CCRoles} from "../../../model/security/cc-roles-type";
import {ContextMenu} from "primeng/contextmenu";
import {UserViewDialogComponent} from "../../internal/user-views-dialog/user-view-dialog.component";
import {ClearingComponent} from "../clearing.component";
import {AppConfigService} from "../../../services/app-config.service";
import {CcStorageService} from "../../../services/common/cc-storage.service";

@Component({
  selector: 'app-clearing-views',
  templateUrl: './clearing-views.component.html',
  styleUrls: ['./clearing-views.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClearingViewsComponent extends CcBaseComponent {

  userViews: WebTradeOrderView[] = [];
  exchanges: FieldRecord<ExchangeDetail>[] = [];
  selectedViewIndex: number = -1;
  initialised: boolean = false;

  viewsContextMenuItems: MenuItem[] = [];

  selectedUserView: WebTradeOrderView;
  userViewFormRecord: WebTradeOrderView;
  userViewFormVisible: boolean;
  userViewsListVisible: boolean;
  activeIndex2: number = 0;
  scrollableTabs: any[] = Array.from({length: 50}, (_, i) => ({
    title: `Tab ${i + 1}`,
    content: `Tab ${i + 1} Content`
  }));

  // @ViewChild('tradeOrders')
  // tradeOrders: ClearingComponent;

  ordersTradesFilter: OrdersTradesFilter = new OrdersTradesFilter();

  transPartKey: string = 'page.clearing.';

  selectedOrderIds: string[] = [];
  orderClearingsActive: boolean = false;
  selectedTradeIds: string[] = [];

  viewEditable: boolean = false;

  @ViewChild('viewContextMenu')
  viewContextMenu: ContextMenu;

  @ViewChild('userViewDialog')
  public userViewDialog: UserViewDialogComponent;

  // @ViewChildren('tradeOrders')
  // tradeOrdersList: QueryList<ClearingComponent>;

  @ViewChild('tradeOrders')
  public tradeOrders: ClearingComponent;

  constructor(cdref: ChangeDetectorRef,
              private storageService: CcStorageService,
              private commonFieldService: CommonFieldService,
              private userViewService: InternalTradeOrderViewService,
              private userInfoStorageService: UserInfoStorageService,
              private appConfigService: AppConfigService,
              protected componentFactoryResolver: ComponentFactoryResolver,
              protected messageService: MessageService,
              protected confirmationService: ConfirmationService,
              protected translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    setTimeout(() => {
      this.commonFieldService.clearStorage();
      this.refreshViews();
    });
  }


  protected initConfigs() {
    super.initConfigs();
    this.viewsContextMenuItems = [];
    this.viewEditable = this.isViewEdit();
    if (this.viewEditable) {
      this.viewsContextMenuItems.push(...[
        {
          label: this.translateService.instant('common.edit'),
          icon: 'fas fa-edit',
          command: event => this.editView()
        }]);
    }
    this.viewsContextMenuItems.push(...[{
      label: this.translateService.instant('common.move-to.left'),
      icon: 'fas fa-long-arrow-alt-left',
      command: event => this.moveView(-1)
    },
      {
        label: this.translateService.instant('common.move-to.right'),
        icon: 'fas fa-long-arrow-alt-right',
        command: event => this.moveView(1)
      }])

    if (this.viewEditable) {
      this.viewsContextMenuItems.push(...[{
        label: this.translateService.instant('common.close'),
        icon: 'fas fa-times',
        command: event => this.closeView()
      }
      ]);
    }
  }

  protected initData() {
    super.initData();
    this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).pipe(takeUntil(this.destroy$)).subscribe(fieldResult => {
      this.exchanges = this.getFields(fieldResult);
    });
    // this.refreshViews();
  }

  // tslint:disable-next-line:use-life-cycle-interface
  // ngOnInit() {
  //   super.ngOnInit();
  //   this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
  //     this.exchanges = this.getFields(fieldResult);
  //   });
  //   this.refreshViews();
  // }

  // tslint:disable-next-line:use-life-cycle-interface
  // ngOnDestroy(): void {
  // }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  setViewIcon(userView: WebTradeOrderView): void {
    if (this.exchanges) {
      const exchField = this.exchanges ? this.exchanges.find(exchange => exchange.value && exchange.value.code === WebTradeOrderView.getFilterValue(userView, 'exchangeCode')) : undefined;
      if (exchField?.value) {
        userView.viewIco = exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
      } else {
        userView.viewIco = 'fas fa-globe-europe';
      }
    }
  }

  viewChanged(index: number) {
    if (!this.appConfigService.clearingKeepTabSelection) {
      this.selectedTradeIds.splice(0);
      this.selectedOrderIds.splice(0);
    }
    if (this.userViews.length > index) {
      this.storageService.set(CookieNames.CLEARING_VIEW_SELECTED, this.userViews[index].viewName);
      this.selectedUserView = this.userViews[index];
    }
    if (this.storageService.check(CookieNames.CLEARING_ORDER_TRADEMODE)) {
      this.orderClearingsActive = JSON.parse(this.storageService.get(CookieNames.CLEARING_ORDER_TRADEMODE));
    }
  }

  editView() {
    if (this.selectedUserView) {
      this.userViewFormRecord = {...this.selectedUserView};
      this.userViewFormVisible = true;
    }
  }

  createView() {
    this.userViewFormRecord = new WebTradeOrderView();
    this.userViewFormRecord.userName = this.userInfoStorageService.getUsernameFromStorage();
    // @ts-ignore
    this.userViewFormRecord.sortingNumber = this.userViews ? Math.max(...this.userViews.map(o => o.sortingNumber)) + 1 : 0;
    this.userViewFormVisible = true;
  }

  moveView(direction: number) {
    if (this.selectedUserView) {
      const viewIndex = this.userViews.filter(value => value.visible).findIndex(value => value.id == this.selectedUserView.id);
      if (viewIndex >= 0) {
        const userViewToReplace = this.userViews.filter(value => value.visible)[viewIndex + direction];
        if (userViewToReplace) {
          const oldOrder = this.selectedUserView.sortOrder;
          this.selectedUserView.sortOrder = userViewToReplace.sortOrder;
          userViewToReplace.sortOrder = oldOrder;
          const viewsToUpdate = [this.selectedUserView, userViewToReplace];
          this.userViewService.saveAll(viewsToUpdate).pipe(takeUntil(this.destroy$)).subscribe(validation => {
            if (validation.success) {
              this.refreshViews();
            } else {
              this.errorMessage(validation.message);
            }
          });
        }
      }
    }
  }

  editViews() {
    this.userViewsListVisible = true;
  }

  closeView() {
    if (this.selectedUserView) {
      this.selectedUserView.visible = false;
      this.userViewService.saveRecord(this.selectedUserView).pipe(takeUntil(this.destroy$)).subscribe(validation => {
        if (validation.success) {
          this.refreshViews();
        } else {
          this.errorMessage(validation.message);
        }
      });

    }
  }

  refreshCurrentView() {
    if (this.tradeOrders) {
      this.tradeOrders.refreshTables();
    }
  }

  refreshViews() {
    this.userViewService.getViews().pipe(takeUntil(this.destroy$)).subscribe(apiValidation => {
      if (apiValidation.success) {
        this.userViews.splice(0);
        this.userViews.push(...apiValidation.item.filter(view => view.visible));
        this.userViews = [...this.userViews];
        this.refreshViewIcon();

        // .sort((a, b) => a.sortingNumber - b.sortingNumber);
        if (this.userViews.length > 0) {
          let currentViewName = undefined;
          if (this.userViews && this.storageService.check(CookieNames.CLEARING_VIEW_SELECTED)) {
            currentViewName = this.storageService.get(CookieNames.CLEARING_VIEW_SELECTED);
          }
          if (!currentViewName) {
            currentViewName = this.userViews[0].viewName;
          }
          let currentUserViewIndex = this.userViews.findIndex(view => view.viewName === currentViewName);
          if (currentUserViewIndex < 0) {
            currentViewName = this.userViews[0].viewName;
            currentUserViewIndex = 0;
          }
          // console.log("----> currentUserViewIndex " + currentUserViewIndex)
          if (currentUserViewIndex >= 0) {
            this.selectedUserView = this.userViews[currentUserViewIndex];
            if (!this.initialised || this.selectedViewIndex != currentUserViewIndex) {
              this.initialised = true;
              if (this.selectedViewIndex == currentUserViewIndex) {
                setTimeout(() => {
                  this.selectedUserView = undefined;
                  this.selectedViewIndex = -1;
                  this.markForCheck();
                });
              }
              setTimeout(() => {
                this.selectedViewIndex = currentUserViewIndex;
                this.markForCheck();
              });
            }
          }
        }
      } else {
        this.userViews = [];
      }
      this.markForCheck();
    });
  }

  private refreshViewIcon() {
    if (this.userViews)
      this.userViews.forEach(userView => this.setViewIcon(userView));
  }

  viewsChanged($event: boolean) {
    if (!$event) {
      this.refreshViews();

    }
  }

  isViewEdit(): boolean {
    return this.hasRoles(CCRoles.ROLES_INTERNAL_TRADEORDER_VIEW);
  }

  showTabContextMenu(event, userView: WebTradeOrderView) {
    this.selectedUserView = userView;
    // if (this.viewEditable)
    this.viewContextMenu.show(event);
  }

}


